export default __webpack_public_path__ + "static/newprd_1-0ce6c4f9fc2e7039d5f79809481f86e2.jpg";